import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";
import {FormatTypes} from "../core/Formater";

export class InvoiceItem extends BaseModel {

	id: string
	title: string
	amount: number
	unitPrice: number
	unitName: string
	price: number
	vatValue: number
	priceWithVat: number
	vat: number
	serviceId: string
	invoiceId: string
	customerId: string
	test: string
}

export class InvoiceItemDescriptor extends BaseModel {
	static id: AttributeDescriptor = {validation: []}
	static serviceId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static amount: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static unitPrice: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED], format: FormatTypes.PRICE}
	static unitName: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static vat: AttributeDescriptor = {validation: []}
}
